import React from 'react'
import { Grid, useMediaQuery, Box, Divider } from '@material-ui/core'
import CommunityCard from 'components/CommunityCard'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import useCurrentUserEntity from 'hooks/useCurrentUserEntity'
import JarCard from 'components/JarCard'

export default function CommunityPage() {
  const { name, logoUrl: imageUrl, description, donationTotal, memberCount } = useCurrentUserEntity('community', 'communities')
  const jarIds = useCurrentUserProp('campaigns')
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('xs'))

  return (
    <Grid container spacing={1} justifyContent='center'>
      <Grid item xs={12} md={9} lg={7}>
        <CommunityCard { ...{ name, imageUrl, description, donationTotal, memberCount, narrowView: isMobile } } />
      </Grid>

      <Grid item xs={12}>
        <Box my={2}>
          <Divider variant='middle' />
        </Box>
      </Grid>

      <Grid item container spacing={isMobile ? 1 : 3}>
        {jarIds.map((id) => (
          <Grid item key={id} xs={12} sm={6} lg={4}>
            <JarCard id={id} />
          </Grid>
        ))}
      </Grid>
    </Grid>
  )
}
